var map = {
	"./CertificationSchemeStandards": 174,
	"./CertificationSchemeStandards.svg": 174,
	"./Dashboard": 175,
	"./Dashboard.svg": 175,
	"./DataPortal": 176,
	"./DataPortal.svg": 176,
	"./DataServices": 177,
	"./DataServices.svg": 177,
	"./DataSource": 178,
	"./DataSource.svg": 178,
	"./Database": 179,
	"./Database.svg": 179,
	"./Dataset": 180,
	"./Dataset.svg": 180,
	"./DigitalPlatforms": 181,
	"./DigitalPlatforms.svg": 181,
	"./DigitalReports": 182,
	"./DigitalReports.svg": 182,
	"./FlexibleAnalysisPlatform": 183,
	"./FlexibleAnalysisPlatform.svg": 183,
	"./InitativeOrganisation": 184,
	"./InitativeOrganisation.svg": 184,
	"./LegendIcon": 185,
	"./LegendIcon.svg": 185,
	"./LibraryCatalogue": 186,
	"./LibraryCatalogue.svg": 186,
	"./Modal": 187,
	"./Modal.svg": 187,
	"./Repository": 188,
	"./Repository.svg": 188,
	"./Software": 189,
	"./Software.svg": 189,
	"./Statistics": 190,
	"./Statistics.svg": 190,
	"./TH_favicon": 191,
	"./TH_favicon.png": 191,
	"./VisualisationDashboard": 192,
	"./VisualisationDashboard.svg": 192,
	"./decisionSupportTool": 193,
	"./decisionSupportTool.svg": 193,
	"./hero-pattern-1": 194,
	"./hero-pattern-1.jpeg": 194,
	"./hero-pattern-2": 195,
	"./hero-pattern-2.jpeg": 195,
	"./logo-GCRF": 123,
	"./logo-GCRF.png": 123,
	"./logo-main": 122,
	"./logo-main.svg": 122,
	"./logo-ukri": 124,
	"./logo-ukri.svg": 124,
	"./wcmc_components": 196,
	"./wcmc_components.svg": 196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 448;